// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AiGeneratorController from "./ai_generator_controller"
application.register("ai-generator", AiGeneratorController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AssessmentBuilderController from "./assessment_builder_controller"
application.register("assessment-builder", AssessmentBuilderController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import BarometerReminderController from "./barometer_reminder_controller"
application.register("barometer-reminder", BarometerReminderController)

import CardRevealController from "./card_reveal_controller"
application.register("card-reveal", CardRevealController)

import CarrouselController from "./carrousel_controller"
application.register("carrousel", CarrouselController)

import ChangelogController from "./changelog_controller"
application.register("changelog", ChangelogController)

import ChapterPlayerController from "./chapter_player_controller"
application.register("chapter-player", ChapterPlayerController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatDrawerController from "./chat_drawer_controller"
application.register("chat-drawer", ChatDrawerController)

import ClaimChatController from "./claim_chat_controller"
application.register("claim-chat", ClaimChatController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ChatMessageController from "./chat_message_controller"
application.register("chat-message", ChatMessageController)

import ClassroomSessionController from "./classroom_session_controller"
application.register("classroom-session", ClassroomSessionController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmationModalController from "./confirmation_modal_controller"
application.register("confirmation-modal", ConfirmationModalController)

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import DataTableController from "./data_table_controller"
application.register("data-table", DataTableController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DependentCheckboxController from "./dependent_checkbox_controller"
application.register("dependent-checkbox", DependentCheckboxController)

// ⚠️ Import maintenu à la main (gem dlnk_ui). `bin/rails stimulus:manifest:update`
// le SUPPRIME car il ne scanne que app/javascript/controllers/. Ne pas régénérer
// le manifest sans réintégrer ces deux lignes (sinon l'assistance IA casse partout).
import DlnkAiTextAssistController from "dlnk_ui/dlnk_ai_text_assist_controller"
application.register("dlnk-ai-text-assist", DlnkAiTextAssistController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DualPanelSelectorController from "./dual_panel_selector_controller"
application.register("dual-panel-selector", DualPanelSelectorController)

import EvaluationAttemptController from "./evaluation_attempt_controller"
application.register("evaluation-attempt", EvaluationAttemptController)

import EvaluationFormController from "./evaluation_form_controller"
application.register("evaluation-form", EvaluationFormController)

import EvaluationParticipationModalController from "./evaluation_participation_modal_controller"
application.register("evaluation-participation-modal", EvaluationParticipationModalController)

import EvaluationQcmOptionsController from "./evaluation_qcm_options_controller"
application.register("evaluation-qcm-options", EvaluationQcmOptionsController)

import EvaluationTimerController from "./evaluation_timer_controller"
application.register("evaluation-timer", EvaluationTimerController)

import EventDispatchController from "./event_dispatch_controller"
application.register("event-dispatch", EventDispatchController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import FloatingLabelController from "./floating_label_controller"
application.register("floating-label", FloatingLabelController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormParticipationController from "./form_participation_controller"
application.register("form-participation", FormParticipationController)

import FormQuestionOptionsController from "./form_question_options_controller"
application.register("form-question-options", FormQuestionOptionsController)

import FormToggleController from "./form_toggle_controller"
application.register("form-toggle", FormToggleController)

import HelpDrawerController from "./help_drawer_controller"
application.register("help-drawer", HelpDrawerController)

import ImageCropperController from "./image_cropper_controller"
application.register("image-cropper", ImageCropperController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import LeafletController from "./leaflet_controller"
application.register("leaflet", LeafletController)

import LiveSessionChatController from "./live_session_chat_controller"
application.register("live-session-chat", LiveSessionChatController)

import LiveSessionController from "./live_session_controller"
application.register("live-session", LiveSessionController)

import LiveSessionJitsiController from "./live_session_jitsi_controller"
application.register("live-session-jitsi", LiveSessionJitsiController)

import LiveSessionPollController from "./live_session_poll_controller"
application.register("live-session-poll", LiveSessionPollController)

import QuizComposerController from "./quiz_composer_controller"
application.register("quiz-composer", QuizComposerController)

import TrainerQuizBoardController from "./trainer_quiz_board_controller"
application.register("trainer-quiz-board", TrainerQuizBoardController)

import StudentQuizBoardController from "./student_quiz_board_controller"
application.register("student-quiz-board", StudentQuizBoardController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModuleSelectorController from "./module_selector_controller"
application.register("module-selector", ModuleSelectorController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotesDrawerController from "./notes_drawer_controller"
application.register("notes-drawer", NotesDrawerController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import OnboardingAcceptCheckboxController from "./onboarding/accept_checkbox_controller"
application.register("onboarding--accept-checkbox", OnboardingAcceptCheckboxController)

import OnboardingLikertScaleController from "./onboarding/likert_scale_controller"
application.register("onboarding--likert-scale", OnboardingLikertScaleController)

import PanelTabsController from "./panel_tabs_controller"
application.register("panel-tabs", PanelTabsController)

import PaperSheetRosterController from "./paper_sheet_roster_controller"
application.register("paper-sheet-roster", PaperSheetRosterController)

import ParticipantSelectorController from "./participant_selector_controller"
application.register("participant-selector", ParticipantSelectorController)

import ParticipationQuestionController from "./participation_question_controller"
application.register("participation-question", ParticipationQuestionController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PdfPreviewController from "./pdf_preview_controller"
application.register("pdf-preview", PdfPreviewController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PresenceController from "./presence_controller"
application.register("presence", PresenceController)

import ProfileEditController from "./profile_edit_controller"
application.register("profile-edit", ProfileEditController)

import ProfileSignatureController from "./profile_signature_controller"
application.register("profile-signature", ProfileSignatureController)

import ProcedureAiDraftController from "./procedure_ai_draft_controller"
application.register("procedure-ai-draft", ProcedureAiDraftController)

import ProfileTabsController from "./profile_tabs_controller"
application.register("profile-tabs", ProfileTabsController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import ProgressBarStepsController from "./progress_bar_steps_controller"
application.register("progress-bar-steps", ProgressBarStepsController)

import ProgressDonutController from "./progress_donut_controller"
application.register("progress-donut", ProgressDonutController)

import ProgressTrackerController from "./progress_tracker_controller"
application.register("progress-tracker", ProgressTrackerController)

import PromotionModuleController from "./promotion_module_controller"
application.register("promotion-module", PromotionModuleController)

import PromotionWizardController from "./promotion_wizard_controller"
application.register("promotion-wizard", PromotionWizardController)

import QualiopiIndicatorFicheController from "./qualiopi_indicator_fiche_controller"
application.register("qualiopi-indicator-fiche", QualiopiIndicatorFicheController)

import QuestionOptionsController from "./question_options_controller"
application.register("question-options", QuestionOptionsController)

import QuickSignController from "./quick_sign_controller"
application.register("quick-sign", QuickSignController)

import QuizBuilderController from "./quiz--builder_controller"
application.register("quiz--builder", QuizBuilderController)

import QuizOptionListController from "./quiz--option_list_controller"
application.register("quiz--option-list", QuizOptionListController)

import QuizQuestionFormController from "./quiz--question_form_controller"
application.register("quiz--question-form", QuizQuestionFormController)

import QuizRunAnswererChoiceController from "./quiz--run_answerer_choice_controller"
application.register("quiz--run-answerer-choice", QuizRunAnswererChoiceController)

import QuizRunAnswererRankingController from "./quiz--run_answerer_ranking_controller"
application.register("quiz--run-answerer-ranking", QuizRunAnswererRankingController)

import QuizRunAnswererShortAnswerController from "./quiz--run_answerer_short_answer_controller"
application.register("quiz--run-answerer-short-answer", QuizRunAnswererShortAnswerController)

import QuizRunAnswererWordCloudController from "./quiz--run_answerer_word_cloud_controller"
application.register("quiz--run-answerer-word-cloud", QuizRunAnswererWordCloudController)

import QuizRunStageController from "./quiz--run_stage_controller"
application.register("quiz--run-stage", QuizRunStageController)

import QuizRunTimerController from "./quiz--run_timer_controller"
application.register("quiz--run-timer", QuizRunTimerController)

import RadarChartController from "./radar_chart_controller"
application.register("radar-chart", RadarChartController)

import ReadingProgressController from "./reading_progress_controller"
application.register("reading-progress", ReadingProgressController)

import ReminderController from "./reminder_controller"
application.register("reminder", ReminderController)

import ResourceFormController from "./resource_form_controller"
application.register("resource-form", ResourceFormController)

import RowActionsMenuController from "./row_actions_menu_controller"
application.register("row-actions-menu", RowActionsMenuController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SessionDocumentController from "./session_document_controller"
application.register("session-document", SessionDocumentController)

import SessionSlotFormController from "./session_slot_form_controller"
application.register("session-slot-form", SessionSlotFormController)

import SettingFormController from "./setting_form_controller"
application.register("setting-form", SettingFormController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import SireneController from "./sirene_controller"
application.register("sirene", SireneController)

import SlotsController from "./slots_controller"
application.register("slots", SlotsController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StarRatingInputController from "./star_rating_input_controller"
application.register("star-rating-input", StarRatingInputController)

import StarsController from "./stars_controller"
application.register("stars", StarsController)

import StudentNavController from "./student_nav_controller"
application.register("student-nav", StudentNavController)

import StudentsDrawerController from "./students_drawer_controller"
application.register("students-drawer", StudentsDrawerController)

import StudentsDrawerSearchController from "./students_drawer_search_controller"
application.register("students-drawer-search", StudentsDrawerSearchController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TagCreatorController from "./tag_creator_controller"
application.register("tag-creator", TagCreatorController)

import TestimonialSliderController from "./testimonial_slider_controller"
application.register("testimonial-slider", TestimonialSliderController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)


import TocController from "./toc_controller"
application.register("toc", TocController)

import ToggleBadgeController from "./toggle_badge_controller"
application.register("toggle-badge", ToggleBadgeController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UserDetailModalController from "./user_detail_modal_controller"
application.register("user-detail-modal", UserDetailModalController)

import ViewToggleController from "./view_toggle_controller"
application.register("view-toggle", ViewToggleController)

import ZecapAiPanelController from "./zecap_ai_panel_controller"
application.register("zecap-ai-panel", ZecapAiPanelController)
